
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/waianapanapa/reservation-details",
      function () {
        return require("private-next-pages/waianapanapa/reservation-details.js");
      }
    ]);
  